// extracted by mini-css-extract-plugin
export default {"partOne":"Smart_partOne__vJUiZ"};